var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('h3',{staticClass:"blue-text"},[_vm._v(_vm._s(_vm.L10n('manually')))]),_c('form-add',{attrs:{"model":_vm.getModel,"data":_vm.dataForm,"disabled":_vm.disabled},on:{"onAddToQuote":_vm.handlerAddToQuote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }